import React from "react";
import { Link, NavLink, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export default function AdminLayout() {
  const { logout } = useAuth();
  return (
    <div>
      <div className="border-bottom bg-white">
        <div className="container d-flex justify-content-between align-items-center py-3">
          <Link to="/" className="fw-bold text-decoration-none">MAMECHE — Admin</Link>
          <div className="d-flex gap-2">
            <Link to="/admin/products" className="btn btn-outline-success btn-sm">Produits</Link>
            <Link to="/admin/works" className="btn btn-outline-secondary btn-sm">Réalisations</Link>
            <Link to="/admin/slides" className="btn btn-outline-secondary btn-sm">Bannières</Link>

            <button onClick={logout} className="btn btn-danger btn-sm">Se déconnecter</button>
          </div>
        </div>
      </div>
      <div className="container py-4">
        <div className="mb-3 d-flex gap-2">
          <NavLink to="/admin/products" className={({isActive}) => "btn btn-sm " + (isActive ? "btn-success" : "btn-outline-success")}>Produits</NavLink>
          <NavLink to="/admin/works" className={({isActive}) => "btn btn-sm " + (isActive ? "btn-secondary" : "btn-outline-secondary")}>Réalisations</NavLink>
        </div>
        <Outlet />
      </div>
    </div>
  );
}
